/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPlayPauseIcon32Regular = forwardRef('MediaUiAPlayPauseIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M24 5a1 1 0 0 1 1 1v20a1 1 0 1 1-2 0V6a1 1 0 0 1 1-1Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7.52c0-1.986 2.203-3.18 3.866-2.095l13.004 8.481c1.512.986 1.512 3.202 0 4.188L5.866 26.575C4.203 27.66 2 26.466 2 24.481V7.519Zm2.773-.42A.5.5 0 0 0 4 7.52v16.96a.5.5 0 0 0 .773.42l13.004-8.481a.5.5 0 0 0 0-.838L4.773 7.101Z" }),
        React.createElement("path", { d: "M31 6a1 1 0 1 0-2 0v20a1 1 0 1 0 2 0V6Z" })));
});
